module.exports = {
      id: "vikatantv-usage",
      viewBox: "0 0 25.176 25.204",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#vikatantv",
      toString: function () {
        return this.url;
      }
    }